<template>
    <suspense>
        <slot />
        <template #fallback>
            <card-normal>
                <template #sections>
                    <card-section area="card-header">
                        <text-decorator bold>
                            Financieel
                        </text-decorator>
                    </card-section>

                    <card-section area="card-footer">
                        <flex-container :gap="Size.sm" justify-content="end">
                            <button-outline disabled>
                                Annuleren
                            </button-outline>

                            <button-block disabled>
                                Opslaan
                            </button-block>
                        </flex-container>
                    </card-section>
                </template>

                <flex-container :gap="Size.sm">
                    <text-heading sub>
                        Omzet en transactie
                    </text-heading>

                    <flex-container>
                        <two-columns class="financial-tab-panel__fields">
                            <input-group v-model="fakeValue">
                                <template #label>
                                    <input-label>Vraagprijs</input-label>
                                </template>
                                <template #input>
                                    <text-input disabled>
                                        <template #prefix>
                                            €
                                        </template>
                                    </text-input>
                                </template>
                            </input-group>

                            <input-group v-model="fakeValue">
                                <template #label>
                                    <input-label>Totale omzet/courtage</input-label>
                                </template>
                                <template #input>
                                    <text-input :disabled="true">
                                        <template #prefix>
                                            €
                                        </template>
                                    </text-input>
                                </template>
                            </input-group>

                            <input-group v-model="fakeValue">
                                <template #label>
                                    <input-label>Transactieprijs</input-label>
                                </template>
                                <template #input>
                                    <text-input :disabled="true">
                                        <template #prefix>
                                            €
                                        </template>
                                    </text-input>
                                </template>
                            </input-group>

                            <input-group v-model="fakeValue">
                                <template #label>
                                    <input-label>Productiedatum</input-label>
                                </template>
                                <template #input>
                                    <text-input :disabled="true">
                                        <template #suffix>
                                            <svg-icon :icon="IconCalendarToday" :size="IconSize.sm" />
                                        </template>
                                    </text-input>
                                </template>
                            </input-group>

                            <input-group v-model="fakeValue">
                                <template #label>
                                    <input-label>Transportdatum</input-label>
                                </template>
                                <template #input>
                                    <text-input :disabled="true">
                                        <template #suffix>
                                            <svg-icon :icon="IconCalendarToday" :size="IconSize.sm" />
                                        </template>
                                    </text-input>
                                </template>
                            </input-group>

                            <input-group v-model="fakeValue">
                                <template #label>
                                    <input-label>Object code</input-label>
                                </template>
                                <template #input>
                                    <text-input :disabled="true" />
                                </template>
                            </input-group>
                        </two-columns>

                        <horizontal-line />

                        <div>
                            <text-heading sub>
                                Verdeling omzet/courtage
                            </text-heading>
                            Voor rapportage kun je de omzetbijdrage verdelen over betrokken medewerkers.<br />
                            Bedragen zijn indicatief en aanpasbaar.
                        </div>

                        <card-normal>
                            <flex-container style="align-items: center">
                                <template v-for="i in 2" :key="i">
                                    <flex-container :size="5">
                                        <bar-skeleton :width="150" />
                                    </flex-container>

                                    <flex-container :size="5">
                                        <input-group v-model="fakeValue">
                                            <template #input>
                                                <text-input :disabled="true">
                                                    <template #suffix>
                                                        <button
                                                            type="button"
                                                            style="all: unset"
                                                        >
                                                            <bar-skeleton :width="15" />&percnt;
                                                        </button>
                                                    </template>
                                                </text-input>
                                            </template>
                                        </input-group>
                                    </flex-container>
                                </template>
                            </flex-container>

                            <template #sections>
                                <card-section area="card-header">
                                    <text-decorator :color="Color.brandPurple">
                                        Omzet bijdrage voor team
                                    </text-decorator>
                                </card-section>
                            </template>
                        </card-normal>

                        <p>
                            Restant toe te wijzen omzet bijdrage aan de betrokken medewerkers na aftrek van de omzet
                            bijdrage van het team:

                            <text-decorator bold>
                                &euro; <bar-skeleton :width="150" />
                            </text-decorator>
                        </p>

                        <card-normal>
                            <div
                                v-for="i in 2"
                                :key="i"
                                class="user-share-grid"
                            >
                                <div>
                                    <bar-skeleton :width="150" />
                                </div>

                                <div>
                                    <input-group v-model="fakeValue">
                                        <template #input>
                                            <text-input :disabled="true">
                                                <template #suffix>
                                                    %
                                                </template>
                                            </text-input>
                                        </template>
                                    </input-group>
                                </div>

                                <div>
                                    <input-group v-model="fakeValue">
                                        <template #input>
                                            <text-input :disabled="true">
                                                <template #prefix>
                                                    €
                                                </template>
                                            </text-input>
                                        </template>
                                    </input-group>
                                </div>

                                <button
                                    type="button"
                                    style="all: unset"
                                    :disabled="true"
                                >
                                    <svg-icon
                                        :icon="IconDelete"
                                        :color="Color.gray400"
                                    />
                                </button>
                            </div>

                            <template #sections>
                                <card-section area="card-header">
                                    <div class="user-share-grid">
                                        <div>
                                            <text-decorator :color="Color.brandPurple">
                                                Medewerkers
                                            </text-decorator>
                                        </div>

                                        <div>
                                            <text-decorator :color="Color.brandPurple">
                                                Courtage (%)
                                            </text-decorator>
                                        </div>

                                        <div>
                                            <text-decorator :color="Color.brandPurple">
                                                Courtage (&euro;)
                                            </text-decorator>
                                        </div>
                                    </div>
                                </card-section>
                                <card-section area="card-footer">
                                    <div class="user-share-grid">
                                        <div>
                                            <text-decorator :color="Color.brandPurple">
                                                Totaal verdeeld:
                                            </text-decorator>
                                        </div>

                                        <div>
                                            <text-decorator :color="Color.brandPurple">
                                                <bar-skeleton :width="150" />&percnt;
                                            </text-decorator>
                                        </div>

                                        <div>
                                            <text-decorator :color="Color.brandPurple">
                                                &euro; <bar-skeleton :width="150" />
                                            </text-decorator>
                                        </div>
                                    </div>
                                </card-section>
                            </template>
                        </card-normal>
                    </flex-container>
                </flex-container>
            </card-normal>
        </template>
    </suspense>
</template>

<script setup lang="ts">
    import {
        Color,
        CardNormal,
        FlexContainer,
        IconSize,
        InputGroup,
        InputLabel,
        SvgIcon,
        TextHeading,
        TextInput,
        HorizontalLine,
        CardSection,
        TextDecorator,
        ButtonOutline,
        ButtonBlock,
        Size,
    } from '@keyvue/one-ui';
    import TwoColumns from '@components/UI/TwoColumns.vue';
    import IconDelete from '@keyvue/one-material-icons/icons/delete.svg?component';
    import IconCalendarToday from '@keyvue/one-material-icons/icons/calendar_today.svg?component';
    import { ref } from 'vue';

    const fakeValue = ref('');
</script>

<style scoped lang="scss">
.financial-tab-panel__fields {
    width: 100%;
    line-height: 125%;
}

.user-share-grid {
    width: 100%;
    display: grid;
    grid-template-columns: auto 20% 20% 24px;
    align-items: center;
    gap: 20px;
    overflow: hidden;
}

.user-share-grid + .user-share-grid {
    margin-top: 10px;
}
</style>
